/*
 * @Description: 
 * @Author: kai.zhou
 * @Date: 2021-07-06 20:10:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-04-16 17:10:45
 */
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";

type Loader = () => Promise<{ default: any }>;
const localeLoaders: Record<string, Loader> = {
  en:   () => import(/* webpackChunkName: "lang-en"    */ "i18n/en.js"),                // 英语
  am:   () => import(/* webpackChunkName: "lang-am"    */ "i18n/js/am-rET.js"),         // 阿姆哈拉语
  ar:   () => import(/* webpackChunkName: "lang-ar"    */ "i18n/js/ar.js"),             // 阿拉伯语
  as:   () => import(/* webpackChunkName: "lang-as"    */ "i18n/js/as.js"),             // 阿萨姆语
  bn:   () => import(/* webpackChunkName: "lang-bn"    */ "i18n/js/bn-rBD.js"),         // 孟加拉语
  ckb:  () => import(/* webpackChunkName: "lang-ckb"   */ "i18n/js/ckb-rIQ.js"),        // 中库尔德语
  es:   () => import(/* webpackChunkName: "lang-es"    */ "i18n/js/es-rUS"),            // 西班牙语
  fa:   () => import(/* webpackChunkName: "lang-fa"    */ "i18n/js/fa"),                // 波斯语
  fr:   () => import(/* webpackChunkName: "lang-fr"    */ "i18n/js/fr"),                // 法语
  gu:   () => import(/* webpackChunkName: "lang-gu"    */ "i18n/js/gu-rIN"),            // 古吉拉特语
  ha:   () => import(/* webpackChunkName: "lang-ha"    */ "i18n/js/ha"),                // 豪萨语
  hi:   () => import(/* webpackChunkName: "lang-hi"    */ "i18n/js/hi"),                // 印地语
  id:   () => import(/* webpackChunkName: "lang-id"    */ "i18n/js/id"),                // 印度尼西亚语
  iw:   () => import(/* webpackChunkName: "lang-iw"    */ "i18n/js/iw"),                // 希伯来语
  kk:   () => import(/* webpackChunkName: "lang-kk"    */ "i18n/js/kk-rKZ"),            // 哈萨克语
  km:   () => import(/* webpackChunkName: "lang-km"    */ "i18n/js/km-rKH"),            // 高棉语
  kn:   () => import(/* webpackChunkName: "lang-kn"    */ "i18n/js/kn-rIN"),            // 卡纳达语
  ks:   () => import(/* webpackChunkName: "lang-ks"    */ "i18n/js/ks"),                // 克什米尔语
  lo:   () => import(/* webpackChunkName: "lang-lo"    */ "i18n/js/lo-rLA"),            // 老挝语
  ml:   () => import(/* webpackChunkName: "lang-ml"    */ "i18n/js/ml"),                // 马拉雅拉姆语
  mr:   () => import(/* webpackChunkName: "lang-mr"    */ "i18n/js/mr-rIN"),            // 马拉地语
  ms:   () => import(/* webpackChunkName: "lang-ms"    */ "i18n/js/ms-rMY"),            // 马来语
  myMM: () => import(/* webpackChunkName: "lang-myMM"  */ "i18n/js/my-rMM"),            // 缅甸语 (Unicode)
  myZG: () => import(/* webpackChunkName: "lang-myZG"  */ "i18n/js/my-rZG"),            // 缅甸语 (Zawgyi)
  ne:   () => import(/* webpackChunkName: "lang-ne"    */ "i18n/js/ne-rNP"),            // 尼泊尔语
  om:   () => import(/* webpackChunkName: "lang-om"    */ "i18n/js/om-rET"),            // 奥罗莫语
  or:   () => import(/* webpackChunkName: "lang-or"    */ "i18n/js/or"),                // 奥里亚语
  pa:   () => import(/* webpackChunkName: "lang-pa"    */ "i18n/js/pa-rIN"),            // 旁遮普语
  ptBR: () => import(/* webpackChunkName: "lang-ptBR"  */ "i18n/js/pt-rBR"),            // 葡萄牙语 (巴西)
  ptPt: () => import(/* webpackChunkName: "lang-ptPt"  */ "i18n/js/pt-rPT"),            // 葡萄牙语 (葡萄牙)
  ru:   () => import(/* webpackChunkName: "lang-ru"    */ "i18n/js/ru"),                // 俄语
  si:   () => import(/* webpackChunkName: "lang-si"    */ "i18n/js/si-rLK"),            // 僧伽罗语
  so:   () => import(/* webpackChunkName: "lang-so"    */ "i18n/js/so"),                // 索马里语
  sw:   () => import(/* webpackChunkName: "lang-sw"    */ "i18n/js/sw"),                // 斯瓦希里语
  ta:   () => import(/* webpackChunkName: "lang-ta"    */ "i18n/js/ta-rIN"),            // 泰米尔语
  te:   () => import(/* webpackChunkName: "lang-te"    */ "i18n/js/te-rIN"),            // 泰卢固语
  th:   () => import(/* webpackChunkName: "lang-th"    */ "i18n/js/th-rTH"),            // 泰语
  ti:   () => import(/* webpackChunkName: "lang-ti"    */ "i18n/js/ti-rET"),            // 提格利尼亚语
  tl:   () => import(/* webpackChunkName: "lang-tl"    */ "i18n/js/tl"),                // 他加禄语
  tr:   () => import(/* webpackChunkName: "lang-tr"    */ "i18n/js/tr"),                // 土耳其语
  uk:   () => import(/* webpackChunkName: "lang-uk"    */ "i18n/js/uk-rUA"),            // 乌克兰语
  ur:   () => import(/* webpackChunkName: "lang-ur"    */ "i18n/js/ur-rPK"),            // 乌尔都语
  // zhCN: () => import(/* webpackChunkName: "lang-zhCN"  */ "i18n/js/values-zh-rCN"),     // 简体中文
  // zhTW: () => import(/* webpackChunkName: "lang-zhTW"  */ "i18n/js/zh-rTW"),            // 繁体中文
  vi:   () => import(/* webpackChunkName: "lang-vi"    */ "i18n/js/vi-rVN"),            // 越南语
};

// 错误链接处理-----#/有参数
let hrefIndex1 = window.location.href.indexOf("?");
let hrefIndex2 = window.location.href.indexOf("#/");
if (hrefIndex1 < hrefIndex2 && hrefIndex1 > -1) {
  let href1 = window.location.href.split("?")[0];
  let href2 = window.location.href.split("?")[1].split("#/")[0];
  let href3 = window.location.href.split("#/")[1];
  if (href3.indexOf("?") > -1) {
    // 有渠道参数
    let phref = href1 + "#/" + href3 + "&" + href2;
    // console.log(phref)
    window.location.href = phref;
  } else {
    let phref = href1 + "#/" + href3 + "?" + href2;
    // console.log(phref)
    window.location.href = phref;
  }
}



// 反向语言
// 阿拉伯语  ar
// 乌尔都语 ur-rPK
// 波斯语 fa
// 哈萨克语 kk-rKZ
// 库尔德语  ckb-rIQ
// 克什米尔语 ks
const rtlList = ['ar', 'ur', 'fa', 'kk', 'ckb', 'ks','iw']
const coulanList = [
  'ar', 'fr', 'en', 'am', 'as', 'bn', 'ckb', 'es', 'fa', 'gu',
  'ha', 'hi', 'id', 'iw', 'kk', 'km', 'kn', 'ks', 'lo',
  'ml', 'mr', 'ms', 'myMM', 'myZG', 'ne', 'om', 'or', 'pa',
  'ptBR', 'ptPt', 'ru', 'si', 'so', 'sw', 'ta', 'te',
  'th', 'ti', 'tl', 'tr', 'uk', 'ur', 'vi',//'zhCN', 'zhTW',
]

let lang =  (navigator.languages && navigator.languages[0]) || navigator.language;
let langUse: string;

// lang='en'

// 设置语言
if (coulanList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
  langUse = lang.split("-")[0].toLowerCase();
} else if (lang.split("-")[0].toLowerCase() === "my") {
  if (lang.toLowerCase().indexOf('zg') > -1) {
    langUse = "myZG";
  } else {
    langUse = 'myMM'
  }
} else if (lang.split("-")[0].toLowerCase() === "pt") {
  if (lang.toLowerCase().indexOf('br') > -1) {
    langUse = "ptBR";
  } else {
    langUse = 'ptPt'
  }
// } else if (lang.split("-")[0].toLowerCase() === "zh") {
//   if (lang.toLowerCase().indexOf('tw') > -1) {
//     langUse = "zhTW";
//   } else {
//     langUse = 'zhCN'
//   }
} else {
  langUse = "en";
}

//语言正反向
if (rtlList.indexOf(lang.split("-")[0].toLowerCase()) > -1) {
  document.body.style.direction = "rtl";
} else {
  document.body.style.direction = "ltr";
}

//url解析入参
function _parseQueryString(queryString: any) {
  if (queryString && queryString.startsWith("?")) {
    const result: any = {};
    queryString
      .slice(1)
      .split("&")
      .forEach((item: any) => {
        const keyValueList = item.split("=");
        result[keyValueList[0]] = decodeURIComponent(keyValueList[1]);
      });
    return result;
  } else {
    return {};
  }
}

// 谷歌埋点---打开所有预约页面的pageview，不区分渠道
let url: any = _parseQueryString("?" + window.location.href.split("?")[1]);
if (url.source) {
  if (url.source.toLowerCase() === 'phonerepairsns') {
    gtag('event', 'Reservation_PV_SNS');
  } else if (url.source.toLowerCase() === 'phonerepairweb') {
    gtag('event', 'Reservation_PV_Web');
  } else if (url.source.toLowerCase() === 'apppost' || url.source.toLowerCase() === 'phonerepair' || url.source.toLowerCase() === 'app') {
    gtag('event', 'Reservation_PV_App');
  } else {
    gtag('event', 'Reservation_PV_' + (url.source.toLowerCase()));
  }
} else {
  gtag('event', 'Reservation_PV_H5');
}


// 判断浏览器是否支持 speculationrules
if (HTMLScriptElement.supports?.('speculationrules')) {
  const specScript = document.createElement('script');
  specScript.type = 'speculationrules';
  let specRules = {
    prerender: [
      {
        source: 'list',
        urls: ['/landing','/order','/model'],
      },
    ],
  };
  specScript.textContent = JSON.stringify(specRules);
  document.body.append(specScript);
}

// 仅加载当前语言包,加载完后再挂载 App
const loadLocale = localeLoaders[langUse] || localeLoaders.en;
loadLocale().then((mod) => {
  intl.init({
    currentLocale: langUse,
    locales: { [langUse]: mod.default },
  }).then(() => {
    ReactDOM.render(<App />, document.getElementById("root"));
  });
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
